import BaseRequest from './BaseRequest';

const schema = 'adminnotification';
/**
 * key base on host:port
 */
export default class NotificationRequest extends BaseRequest {
  /**
   *
   * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
   */
  fetchNotification(params) {
    const url = `${schema}/paginate`;
    return this.get(url, params);
  }

  addNotification(params) {
    const url = `${schema}`;
    return this.post(url, params);
  }

  updateNotification(params) {
    const url = `${schema}`;
    return this.put(url, params);
  }

  deleteNotification(params) {
    const url = `${schema}/?id=${params}`;
    return this.del(url);
  }
}
